import { FormEvent, useState, useContext, useCallback } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { AuthContext } from "../../contexts/Auth"
import { ModalEstadoContext } from "../../contexts/ModalEstado"
import { auth, buscarProjetos } from "../../services/auth"
import { projetosUsuario } from "../../interfaces/auth"
import { io } from "socket.io-client"
import { Button } from "../Styles"
import { toast } from "react-toastify"
import { authGoogle } from "../../services/google"
import { criptografarDado, descriptografarDado } from "../../helpers"
import { AuthGoogle } from "../../helpers/auth"
import ModalProjetosUsuario from "../ModalProjetosUsuario"
import ModalRecuperarSenha from "../ModalRecuperarSenha"
import whatsAppImg from '../../assets/img/whatsapp.png'
import logoImg from '../../assets/img/logo.png'
import googleImg from '../../assets/img/google.png'
import "./auth.css"

function Login() {

  const navigate = useNavigate()
  const { search, pathname } = useLocation()

  const paramsUrl = new URLSearchParams(search)
  const idProjeto = paramsUrl.get('idProjeto')
  const grupo = paramsUrl.get("grupo");
  const idOrganizacao = paramsUrl.get("o-s");

  const { isAuth } = useContext(AuthContext)
  const { modal, modalExibir } = useContext(ModalEstadoContext)

  const [email, setEmail] = useState("")
  const [senha, setSenha] = useState("")
  const [projetosUsuario, setProjetosUsuarios] = useState<projetosUsuario[]>([])
  const [btnEntrar, setBtnEntrar] = useState(true)
  const [processando, setProcessando] = useState(false)
  const [modalRecuperarSenha, setModalRecuperarSenha] = useState(false);

  function dadosInvalidosLogin() {
    setProcessando(false)
    setBtnEntrar(true)
    return toast.error("Dados Inválidos. Tente novamente")
  }

  function exibirModalRecuperarSenha() {
    setModalRecuperarSenha(true)
  }


  const buscarProjetosUser = async (e: FormEvent) => {

    e.preventDefault()
    setProcessando(true)

    try {
      const payload = {
        email
      }

      const resposta = await buscarProjetos(payload)

      setProcessando(false)

      if (resposta.data.length === 0) {
        toast.warn("Nenhum projeto encontrado para o e-mail informado")
        modalExibir("")
        return
      }
      if (resposta.status === 200 && resposta.data.length === 1) {
        const idProjeto = resposta.data[0].id.toString()
        const idProjetoCript = criptografarDado(idProjeto)
        return navigate(`${pathname}?grupo=${resposta.data[0].grupo}&idProjeto=${idProjetoCript}&o-s=${resposta.data[0].idOrganizacao}`)
      }

      setProjetosUsuarios(resposta.data)
      
      return modalExibir("ModalProjetosUsuario")

    } catch (error: any) {

      if (error.response.status === 404) {
        setProcessando(false)
        return toast.error("Dados não Encontrado.")
      }

      return toast.error('Falha ao Processar a sua Solicitação')

    }
  }

  async function Auth(e: FormEvent) {
    e.preventDefault()
    setBtnEntrar(false)
    setProcessando(true)

    if (idProjeto === null || !idOrganizacao || idOrganizacao === null) {
      return setProcessando(false)
    }

    const payload = {
      email,
      senha,
      idOrganizacao
    };

    try {

      const resposta = await auth(payload)

      if (resposta.status === 200) {

        const data = new Date()
        const validadeToken = new Date(data.getTime() + 60 * 60 * 4 * 1000)

        const token = resposta.data.token;
        document.cookie = `authGesttor=${token}; expires=true ${validadeToken.toUTCString()}`

        localStorage.setItem("perfilGesttor", `${criptografarDado(resposta.data.perfil)}`)
        localStorage.setItem('usuarioGesttor', `${resposta.data.id}`)
        localStorage.setItem("organizacaoGesttor", `${resposta.data.idOrganizacao}`)
        localStorage.setItem("usuarioGesttorAvatar", `${resposta.data.avatar}`)
        localStorage.setItem("organizacaoGesttorAvatar", `${resposta.data.organizacaoAvatar}`)
        localStorage.setItem('authGesttor', 'true')
        resposta.data.usuarioProjeto === true && localStorage.setItem("usuarioProjeto", resposta.data.usuarioProjeto)

        setBtnEntrar(true)
        setProcessando(false)

        const organizacao = resposta.data.idOrganizacao
        const usuario = resposta.data.id

        const socket = io(`${process.env.REACT_APP_API_GESTTOR}?idOrganizacao=${organizacao}`)

        const mensagemDados = {
          usuario
        }

        socket.emit('notificacaoUsuario', organizacao, mensagemDados)

        isAuth()

        if (grupo === "Desenvolvimento de Software") return navigate(`/kanban?idProjeto=${idProjeto}&grupo=${grupo}`)
        return navigate(`/desafios?idProjeto=${idProjeto}&grupo=${grupo}`)
      }

    } catch (error: any) {

      if (error.response.status === 400) return dadosInvalidosLogin()

      if (error.response.status === 408)  {
          setProcessando(false)

          const idCadastroCript = error.response.data.idCadastro;
          const urlHg = process.env.REACT_APP_URL_HG;
          const returnUrl = window.location.origin;

          if (!idCadastroCript) {
              return toast.warning("Licença expirada. Entre em contato com o suporte.");
          }

          const idCadastro = descriptografarDado(idCadastroCript);
          let tempo = 3;

          const toastId = "redirecionamento-cobranca";
          toast.warning(`Licença expirada. Redirecionando para a página de cobrança em ${tempo}s...`, {
              toastId,
              autoClose: 3000,
          });

          const cronometro = setInterval(() => {
              tempo--;

              if (tempo > 0) {
                  toast.update(toastId, {
                      render: `Licença expirada. Redirecionando para a página de cobrança em ${tempo}s...`,
                      type: "warning",
                  });
              } else {
                  clearInterval(cronometro);
                  window.location.href = `${urlHg}/cobranca/${idCadastro}?returnUrl=${returnUrl}`;
              }
          }, 1000);

          return;
      }

      if (error.response.status === 0) toast.error("Serviço Indisponível. Tente novamente mais tarde.")

      if (error.response.status === 403) toast.error("Acesso Negado. Fale com o administrador da sua empresa para liberar o acesso.")

      setBtnEntrar(true);
      return setProcessando(false);
    }
  }

  const loginComGoogle = useCallback(async () => {
    try {
      const listener = async (event: MessageEvent) => {

        if (event.origin === process.env.REACT_APP_API_PROJETOS_GESTTOR && event.data.type === 'google-auth-sucesso') {

          window.removeEventListener('message', listener)

          const email = event.data.usuario
          const tokens = event.data.token

          const resposta = await buscarProjetos({ email })

          if (resposta.data.length === 1) {
            return AuthGoogle({
              idOrganizacao: resposta.data[0].idOrganizacao,
              email,
              tokens,
              idProjeto: resposta.data[0].id,
              grupo: resposta.data[0].grupo,
              isAuth,
              navigate
            })
          }

          if (resposta.data.length === 0) {
            toast.warn("Nenhum projeto encontrado para o e-mail informado")
            modalExibir("")
            return
          }
          navigate(`${pathname}#${tokens}#${email}`)
          setProjetosUsuarios(resposta.data)
          return modalExibir('ModalProjetosUsuario')
        }
      }

      const listenerSemDados = (event: MessageEvent) => {

        if (event.origin === process.env.REACT_APP_API_PROJETOS_GESTTOR && event.data === 'google-auth-sucesso/sem-dados') {
          window.removeEventListener('message', listener)

          toast.error('Dados Não Encontrados. Tente com outra Conta')
        }
      }

      window.addEventListener('message', listenerSemDados)

      const resposta = await authGoogle()
      window.open(resposta.data, '_blank', 'width=600,height=800')

      window.addEventListener('message', listener)

    } catch (error) {

      return toast.error('Erro no login com Google')
    }

  }, [isAuth, modalExibir, navigate, pathname]
  )

  return (
    <div id="fundoLogin">
      {modal.nome === 'ModalProjetosUsuario' && <ModalProjetosUsuario dados={projetosUsuario} />}
      {modalRecuperarSenha && <ModalRecuperarSenha />}
      <section id="containerEsquerdoLogin">
        <div id="containerFormLogin">
          <img id="logoSistemaGesttor" src={logoImg} alt="logo do Sistema Gesttor" />
          <span>
            <h1>Login</h1>
          </span>

          <div className='containerGoogleAuth' onClick={loginComGoogle}>
            <img src={googleImg} alt='' />
            <p>Login com o Google</p>
          </div>
          <form id="formLogin" onSubmit={idProjeto === null ? buscarProjetosUser : Auth}>
            <span className="formCampo">
              <label htmlFor="campoEmail">Usuário</label>
              <input
                type="email"
                id="campoEmail"
                className="email"
                placeholder="insira seu e-mail"
                required
                onChange={(e) => setEmail(e.target.value)}
              ></input>
            </span>
            {idProjeto && <span className="formCampo">
              <label htmlFor="campoSenha">Senha</label>
              <input
                type="password"
                id="campoSenha"
                className="senha"
                placeholder="insira sua senha com 8 dígitos"
                minLength={8}
                maxLength={8}
                required
                onChange={(e) => setSenha(e.target.value)}
              ></input>
            </span>}
            <span>
              <p
                id="recuperarSenha"
                onClick={() => exibirModalRecuperarSenha()}
              >
                Esqueci Minha Senha
              </p>
            </span>
            <span id="formEntrar">
              {btnEntrar && <Button type="submit" isLoading={processando} cor='continuarSucesso'>Continuar</Button>}
            </span>
          </form>
        </div>
      </section>
      <section id="containerDireitoLogin" />
      <a href="https://wa.me/message/YYTHX6J2OKZ3O1" target="_blanck">
        <span id="suporteSistemaGesttor">
          <img src={whatsAppImg} alt="" title="Como podemos te ajudar?" />
          <p>Como podemos te ajudar?</p>
        </span>
      </a>
    </div>
  )
}

export default Login
